import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Company } from "../company/company.model";


@CwtModel({ name: 'company-product-accessory' })
@CwtCrudContract({ path: 'company/:companyId/company-product-accessory' })
export class CompanyProductAccessory extends CwtApiEntity {
    @CwtProp({ ref: Company }) company: Company;
    @CwtProp() name: string;
}